import Action from './action';

const initialState = {
    BankPhoneNumber: '',
    errorText: '',
};

export default (state = initialState, action: {type: string, playload: string}) => {
    switch (action.type) {
        case Action.UPDATE_BANK_PHONE_NUMBER: {
            return {
                ...state,
                BankPhoneNumber: action.playload
            }
        }
        case Action.UPDATE_BANK_PHONE_NUMBER_ERROR_TEXT: {
            try {
                action.playload && (window as any).mailStats.show('BankPhoneNumber_error', { errorText: action.playload })
            } catch(e) {}
            return {
                ...state,
                errorText: action.playload
            }
        }
        default: return state;
    }
}
